import { skipToken, useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { ProjectTemplate } from "tekkr-common/dist/model/project/project-template";

export function useGetTemplateQuery(templateId: string | undefined) {
    return useQuery({
        queryKey: ["template", templateId],
        queryFn: templateId
            ? async (): Promise<ProjectTemplate> => {
                  const res = await apiClient.getProjectTemplate({
                      params: { templateId },
                  });
                  if (res.status !== 200) {
                      throw new Error("Failed to fetch template");
                  }
                  return res.body.data;
              }
            : skipToken,
    });
}
